import { Inbox, InboxContent } from "@novu/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import Config from "~/config/env";
import { appearance } from "~/components/notifications/appearance";
import {
  getPathFromNotification,
  HSPNotification,
} from "~/components/notifications/utils";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import { useEffect } from "react";
import { fetchServices } from "../global-entities/globalEntitiesSlice";
import { getEntityAcess } from "../settings/users/invite-modal/InviteModalSlice";

// const subscriberId = "novu_fa356233-91d5-4ac4-9d3e-d92b1366c263";
// const applicationIdentifier = "C8p8iAqchvwx";

export function NovuInbox() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id: user_id, role } = useSelector((state) => state.login);
  const entityservices = useSelector(
    (state) => state.globalEntities.entityservices,
  );
  const { useraccess } = useSelector((state) => state.inviteusers);
  const { value: isEscalationsFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.ESCALATIONS,
    false,
  );
  const { value: isRequestsFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.REQUESTS,
    false,
  );
  const { value: isPayslipUploadFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.PAYSLIP_UPLOAD,
    false,
  );
  // GXM-1724: services can be either plain UUID strings or objects with id property
  // Handle both formats for backward compatibility
  const uniqueServices = [
    ...new Set(
      useraccess?.flatMap(
        (item) =>
          item?.services?.map((service) =>
            typeof service === "string" ? service : service?.id,
          ) || [],
      ),
    ),
  ];
  const accessService = entityservices?.filter((service) =>
    uniqueServices?.includes(service?.id),
  );
  const hasPayrollAccess = accessService?.some(
    (data) => data?.name === "Payroll",
  );

  useEffect(() => {
    dispatch(fetchServices());
    dispatch(getEntityAcess(user_id));
  }, []);

  const subscriberId = useSelector((state) => state.login.subscriber);
  const applicationIdentifier = Config.NOVU_APP_IDENTIFIER;

  const navigationHandler = (notification: Notification) => {
    const path = getPathFromNotification(notification as HSPNotification);
    navigate(path);
  };

  const handleAppearance = () => {
    const escalation = ["escalation-raised", "escalation-updates"];
    const request = ["request-update", "new-request", "ad-hoc-status-update"];
    const payrollPayslip = [
      "payroll-payslip-processing",
      "payroll-payslip-processing-completion",
    ];
    const process = [
      "process-start-reminder",
      "task-due-tomorrow",
      "overdue-status-change",
      "flag-task",
      "new-message",
      "task-status-change",
      "comment-on-task",
    ];
    return {
      ...appearance,
      elements: {
        ...appearance.elements,
        workflowContainer: ({ preference }) => {
          const identifier = preference?.workflow?.identifier;
          if (escalation.includes(identifier)) {
            return isEscalationsFeatureEnabled &&
              !["LSP_USER", "LSP_MANAGER"].includes(role)
              ? ""
              : "hidden";
          } else if (request.includes(identifier)) {
            return isRequestsFeatureEnabled ? "" : "hidden";
          } else if (payrollPayslip.includes(identifier)) {
            return hasPayrollAccess && isPayslipUploadFeatureEnabled
              ? ""
              : "hidden";
          } else if (process.includes(identifier)) {
            return accessService?.length ? "" : "hidden";
          } else {
            return "";
          }
        },
      },
    };
  };
  return (
    <Inbox
      applicationIdentifier={applicationIdentifier}
      subscriber={subscriberId}
      appearance={handleAppearance()}
      routerPush={(path: string) => {
        navigate(path);
      }}
    >
      <InboxContent onNotificationClick={navigationHandler} />
    </Inbox>
  );
}
